import { useMemo } from 'react'
import { motion } from 'framer-motion'

interface Ball {
  id: number
  x: number
  y: number
  size: number
  duration: number
  delay: number
  drift: number
}

/** Ambient drifting soccer balls behind hero content. Respects prefers-reduced-motion. */
export function ParticleBalls({ count = 7 }: { count?: number }) {
  const balls = useMemo<Ball[]>(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        x: (i * 137 + 40) % 100,
        y: (i * 79 + 20) % 100,
        size: 8 + ((i * 13) % 14),
        duration: 22 + ((i * 5) % 12),
        delay: (i * 1.7) % 6,
        drift: ((i % 2 === 0 ? 1 : -1) * (60 + (i * 17) % 60)),
      })),
    [count]
  )

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {balls.map((b) => (
        <motion.div
          key={b.id}
          className="absolute opacity-25 motion-reduce:hidden"
          style={{ left: `${b.x}%`, top: `${b.y}%`, width: b.size, height: b.size }}
          initial={{ y: 0, x: 0, rotate: 0 }}
          animate={{ y: [-30, -260], x: [0, b.drift], rotate: [0, 540] }}
          transition={{
            duration: b.duration,
            delay: b.delay,
            repeat: Infinity,
            ease: 'linear',
          }}
        >
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
            <circle cx="12" cy="12" r="11" fill="#FFFFFF" stroke="#0A0A0A" strokeWidth="1" />
            <polygon points="12,7 15.5,9.4 14.2,13.4 9.8,13.4 8.5,9.4" fill="#0A0A0A" />
          </svg>
        </motion.div>
      ))}
    </div>
  )
}
